import React from "react"
function Footer () {
    return(
        <footer>Все права защищены &copy;</footer>
    )
}
export default Footer;